"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteringParameters = void 0;
/**
 * Describes default filtering parameters that can be used.
 * When pagination parameters are not specified, default values are set.
 */
var FilteringParameters = /** @class */ (function () {
    function FilteringParameters(count, offset) {
        if (count === void 0) { count = 100; }
        if (offset === void 0) { offset = 0; }
        this.count = count;
        this.offset = offset;
    }
    return FilteringParameters;
}());
exports.FilteringParameters = FilteringParameters;
//# sourceMappingURL=FilteringParameters.js.map